import { NgModule } from '@angular/core';
import { S126gS126m01Component } from './s126g-s126m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S126gS126m01Component]
})
export class S126gModule { }

